module.exports = __webpack_public_path__ + "static/media/btn_webmoney670ca394af41ff7e90a3ca5797240485.webp";